<template>
  <div
    class="nav-left"
    :class="{ open: isLeftNavbarVisible }"
    :style="[
      isLeftNavWidthChanging
        ? { transitionDuration: `0.1s` }
        : { transitionDuration: `0.7s` },
    ]"
    @mouseover="toggleCloseButton(true)"
    @mouseleave="toggleCloseButton(false)"
    id="leftNavBarID"
  >
    <div
      class="logo-wrapper"
      :class="{
        'px-30': isLeftNavbarVisible,
        'scroll-visible': isDatabaseScrollActive,
      }"
    >
      <div class="left-navbar-visible fade-in" v-if="isLeftNavbarVisible">
        <img src="../assets/logo.svg" />
      </div>
      <!-- <div
              class="round-button refresh"
              :class="{ rotation: isRefreshingOnNavbar }"
            >
              <img
                src="../assets/img/refresh.svg"
                @click="$emit('getCustomDatabases')"
              />
            </div> -->
      <div
        class="btn-close"
        v-if="isCloseButtonVisible"
        @click="closeLeftNav"
      ></div>
    </div>
    <IconPicker
      v-click-outside="onDatabaseIconClick"
      ref="iconPicker"
      :isFieldIcon="true"
      v-show="activeDatabaseIconSelection"
      :displayIconPickerSections="['icon', 'custom']"
      @updateUrl="updateUrl($event, activeDatabaseIconSelection)"
      @onToggleTab="onToggleTab"
      :element="activeDatabaseIconSelection"
    />
    <div class="search-container" v-if="isNavbarScrollable()">
      <div
        class="search"
        :class="{
          active: isLeftNavbarVisible ? searchData.searchActive : false,
        }"
      >
        <span class="search-icon" @click="toggleSearch"></span
        ><input
          type="text"
          @input="onSearch"
          :value="searchData.search"
          name="search"
          autocomplete="off"
          ref="search"
          :style="{
            width: getDynamicWidth,
          }"
        />
      </div>
    </div>
    <div class="menu2-bar" @wheel="isScrollWheelActive">
      <div
        id="navbarScrollContainer"
        class="menu-list-wrap"
        :style="{ 'max-height': getMaxHeight() }"
        :class="{
          'position-unset': databaseDraggingObject.isDraggingDatabase,
        }"
      >
        <!--TODO: Delete v-show if we want to display APP tab -->
        <ul class="menu-list-item" v-if="activeSection == 'data'">
          <!-- :style="{ height: `${sortedDatabases.length * 40}px` }" -->
          <li class="list-item no-item" v-if="isSearchDataEmpty()">
            Es wurde keine passende Datenbank gefunden
          </li>
          <li
            v-for="(page, databaseIndex) in getFilteredDatabases"
            :id="page.name"
            :key="page.name"
            class="list-item"
            :class="{
              active: page.name == activeDatabase.name,
            }"
            @mousedown="moveStart($event, page.name, databaseIndex)"
            :style="{ position: isDatabaseLoading === page.name && 'relative' }"
          >
            <div class="loading-overlay" v-if="isDatabaseLoading === page.name">
              <div class="progress-icon"></div>
            </div>
            <span
              class="horizontal-hidden-top-dropping-line"
              :class="{
                dragActive:
                  activeDropZone < currentDraggingDbIndex &&
                  activeDropZone == databaseIndex,
              }"
            ></span>

            <div class="left-menu-list">
              <div
                class="left-menu-list-name"
                @click="goTo(activeSection, page.name)"
              >
                <span class="database-image-wrapper"
                  ><img
                    :src="
                      page.icon && page.icon !== 'null'
                        ? page.icon
                        : require('../assets/img/database.svg')
                    "
                    @click.stop="onDatabaseIconClick($event, page)"
                  />
                </span>
                <a>{{ page.caption }} </a>

                <div class="leftnav-icons-wrap">
                  <DropdownComponent
                    class="dropdown-btn database-action"
                    :currentDatabase="page"
                    :actionOptions="getActionOptions(page)"
                    @onDropDownItemSelect="
                      (type) => onDropDownItemSelect(type, page)
                    "
                    @close="hideDropdownComponent(page.name)"
                  />
                </div>
              </div>
            </div>

            <span
              class="horizontal-hidden-bottom-dropping-line"
              :class="{
                dragActive:
                  activeDropZone > currentDraggingDbIndex &&
                  activeDropZone == databaseIndex,
              }"
            ></span>
            <b-tooltip
              custom-class="rename-tooltip"
              :target="page.name"
              placement="bottom"
              :show.sync="selectedTableToRename === page.name"
              triggers="none"
            >
              <div class="rename-popup">
                <div class="icon"><img src="../assets/img/database.svg" /></div>
                <div class="rename-input">
                  <input
                    type="text"
                    ref="renameInput"
                    autofocus
                    v-model="page.caption"
                    @keydown.enter="
                      onDataBaseNameChange(page);
                      disableToolTip();
                    "
                    @blur="
                      onDataBaseNameChange(page);
                      disableToolTip();
                    "
                  />
                </div>
              </div>
            </b-tooltip>
          </li>
        </ul>
      </div>
      <div class="left-bar-bottom">
        <span
          class="left-bar-bottom-overlay"
          v-if="databaseDraggingObject.isDraggingDatabase"
        ></span>
        <ul>
          <li class="list-item last-item">
            <div
              class="item"
              @click="toggleNewDataType()"
              v-if="hasCustomAddNewPermission"
            >
              <i class="far fa-plus-square visible"></i>&nbsp;&nbsp; Weiterer
              Inhalt erstellen
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      @mousedown="mouseDownOnLeftNavResizable($event)"
      class="vertical-resizable-nav-line"
      :class="{ isResizing: isLeftNavWidthChanging }"
    ></div>
  </div>
</template>

<script>
import store from '../store/store';

import { updateTableSchema } from '../services/userTable.js';
import DropdownComponent from './widgets/DropdownComponent.vue';
import IconPicker from './widgets/IconPicker.vue';
import { createDatabaseTable } from '../services/customdb.service';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { debouncer, getFlowLastId } from '../utils/helpers';
import { fetchUserAccessLevelApi } from '../services/user.service';

export default {
  name: 'NavbarLeft',
  data() {
    return {
      showMore: false,
      isConfirmationModalVisible: false,
      hasCustomAddNewPermission: false,
      activeDropZone: null,
      currentDraggingDbIndex: null,
      sortedDatabases: [],
      isLeftNavWidthChanging: false,
      actionOptions: [
        {
          icon: 'share',
          label: 'Teilen',
          key: 'share',
          action: 'shareDatabase',
        },
        {
          icon: 'trash',
          label: 'Löschen',
          key: 'remove',
          action: 'removeDatabase',
        },
        {
          icon: 'edit',
          label: 'Anpassen',
          key: 'edit',
          action: 'editDatabase',
        },
        {
          icon: 'copy',
          label: 'Duplizieren',
          key: 'copy',
          action: 'copyDatabase',
        },
        {
          icon: 'plus',
          label: 'Workflow erstellen',
          key: 'createWorkflow',
          action: 'createWorkflow',
        },
        {
          icon: 'sign-out-alt',
          label: 'Verlassen',
          key: 'leave',
          action: 'leaveDatabase',
        },
        {
          imageName: 'rename--icon.png',
          label: 'Umbenennen',
          key: 'rename',
          action: 'onRenameDbOptionSelect',
        },
      ],
      selectedTableToRename: null,
      currentlyChangingTableName: null,
      isDatabaseScrollActive: false,
      databaseScrollTimeOut: 0,
      isCloseButtonVisible: false,
      activeDatabaseIconSelection: null,
      iconPickerPosition: null,
      isDatabaseLoading: null,
      databaseDraggingObject: {
        isDraggingDatabase: false,
        parent: null,
        parentRect: null,
        scrollContainer: null,
        draggable: null,
        draggingRectArea1: null,
        draggingRectArea2: null,
        startingPosition: null,
        scrollSpeed: 12,
        scrollInterval: null,
      },
      searchData: {
        search: null,
        searchActive: false,
      },
    };
  },
  props: {
    customUserNavItems: Array,
    activeDatabase: Object,
    isLeftNavbarVisible: Boolean,
    isRefreshingOnNavbar: Boolean,
    leftNavbarWidth: Number,
  },
  methods: {
    isSearchDataEmpty() {
      return (
        this.searchData.search !== null &&
        this.searchData.search.trim() !== '' &&
        this.getFilteredDatabases.length === 0
      );
    },
    toggleSearch() {
      this.searchData.searchActive = !this.searchData.searchActive;
      if (this.searchData.searchActive) {
        this.$refs.search.focus();
      } else {
        this.searchData.search = null;
      }
    },
    onSearch(e) {
      debouncer(
        () => {
          this.searchData.search = e.target.value;
        },
        100,
        this,
        'searchDebounceTimer'
      );
    },
    isNavbarScrollable() {
      if (this.searchData.search !== null || this.searchData.search !== '') {
        return true;
      }

      const scrollContainer = document.getElementById('navbarScrollContainer');

      if (scrollContainer) {
        const hasVerticalScrollbar =
          scrollContainer.scrollHeight > scrollContainer.clientHeight;
        return hasVerticalScrollbar;
      }

      return false;
    },
    getMaxHeight() {
      return this.isNavbarScrollable()
        ? 'calc(100% - (44px + 52px + 10px))'
        : 'calc(100% - 52px)';
    },
    toggleList: function () {
      this.showMore = !this.showMore;
    },
    showList: function () {
      this.showMore = true;
    },
    hideList: function () {
      this.showMore = false;
    },
    getTitle: function () {
      if (this.$route.params.title) return this.$route.params.title;
      else return this.appSettings('title');
    },
    shareDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleShareDatabase', dataBase);
    },
    removeDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleRemoveDatabase', dataBase);
    },
    leaveDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleLeaveDatabase', dataBase);
    },
    editDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleEditDatabaseSchema', dataBase);
    },
    async copyDatabase(dataBaseName, database) {
      this.isDatabaseLoading = dataBaseName;
      if (this.activeDatabase.name != dataBaseName) {
        await this.goTo('data', dataBaseName);
      }

      this.copyDbRecursiveFunc(database, null);
    },
    async copyDbRecursiveFunc(database, tablenameSuffix) {
      // removed finally, as function is recursive, need to control loading manually
      try {
        if (tablenameSuffix >= 10 || parseInt(tablenameSuffix) >= 10)
          throw {
            customError:
              'Fehler bei der Erstellung der neuen Datenbank. Bitte probieren Sie es erneut oder kontaktieren einen Administrator',
          };

        const formData = new FormData();

        Object.keys(database).map((key) => {
          if (key === 'name') {
            const tempTablename =
              tablenameSuffix === null
                ? `${this.getUserId}_${database.caption}`
                : `${this.getUserId}_${database.caption}-${tablenameSuffix}`;

            formData.append('tablename', tempTablename);
          } else if (key === 'caption') {
            formData.append(
              'caption',
              `Kopie-${database.caption}-${moment().format('DD.MM.YYYY')}`
            );
          } else if (key === 'type') {
            formData.append('tabletype', database.type);
          } else if (!['access_level'].includes(key)) {
            formData.append(key, database[key]);
          }

          // else if (['schema', 'layout', 'credentials', 'sql_cdls', 'tags'].includes(key)) {
          //   formData.append(key, database[key]);
          // }
        });

        const response = await createDatabaseTable(formData);
        this.$emit('toggleCopyDatabase');

        if (response.status === 200 && response.data) {
          this.$bvToast.toast('Datenbank erfolgreich kopiert', {
            title: 'Erfolgreich', //success
            variant: 'success',
            solid: true,
          });
          this.isDatabaseLoading = null;
        }
      } catch (e) {
        if (
          e &&
          e.status === 400 &&
          e.data &&
          e.data.message === 'Table already exists.'
        ) {
          this.copyDbRecursiveFunc(database, tablenameSuffix + 1);
        } else {
          let errormsg = e.customError
            ? e.customError
            : 'Das Kopieren der Datenbank ist fehlgeschlagen.';
          this.$bvToast.toast(errormsg, {
            title: 'Fehler', //error
            variant: 'danger',
            solid: true,
          });
          this.isDatabaseLoading = null;
        }
      }
    },
    async createWorkflow(dataBaseName, database) {
      this.isDatabaseLoading = dataBaseName;

      try {
        const response = await this.$store.dispatch('createNewFlow', {
          id: getFlowLastId(this),
          type: 'app',
          navbarElements:
            database.schema && JSON.parse(database.schema).length
              ? JSON.parse(database.schema)
              : [],
        });

        if (
          response &&
          response !== 'Access Token has expired' &&
          typeof response === 'number'
        ) {
          this.$bvToast.toast('Workflow erfolgreich erstellt', {
            title: 'Erfolgreich', //success
            variant: 'success',
            solid: true,
          });

          const routeData = this.$router.resolve({
            path: '/',
            query: {
              section: 'process-designer',
              process: response,
            },
          });
          window.open(routeData.href, '_blank');
        }
      } catch (error) {
        this.$bvToast.toast(error, {
          title: 'Fehler', //error
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.isDatabaseLoading = null;
      }
    },
    onRenameDbOptionSelect(dataBaseName) {
      this.selectedTableToRename = dataBaseName;
      setTimeout(() => {
        this.$refs['renameInput'][0].focus();
      }, 100);
    },

    goTo: async function (section, database = null, processId) {
      let prop = database ? 'database' : 'processId';
      let val = database ? database : processId;
      if (database) {
        const updatedUserSettings = {
          ...this.userSettings,
          selectedDatabase: database,
        };
        this.$store.dispatch('updateUserSettings', updatedUserSettings);
      }
      let rslt = await this.$router.push({
        path: '/',
        query: { section: section, [prop]: val },
      });
      return rslt;
    },
    getUserCustomDatabases: function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.customUserNavItems = json;
        });
    },
    toggleNewDataType: function () {
      this.$emit('toggleNewDataType');
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    userHasTableEditPermission: function (accessLevel) {
      let editPermissions = ['full_access', 'owner'];
      if (editPermissions.includes(accessLevel)) return true;
      else return false;
    },
    async fetchUserAccessLevel() {
      try {
        const fetchUserAccessLevelResponse = await fetchUserAccessLevelApi(
          this.user.username,
          `databases`
        );

        if (
          fetchUserAccessLevelResponse.data.policies.length > 0 &&
          fetchUserAccessLevelResponse.data.policies[0].access_level == 'edit'
        )
          this.hasCustomAddNewPermission = true;
        else this.hasCustomAddNewPermission = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error :>> ', error);
      }
    },
    closeLeftNav() {
      this.$emit('toggleLeftNavbar', false);
      const updatedUserSettings = {
        ...this.userSettings,
        isShowLeftNavbar: false,
        leftNavbarWidth: this.leftNavbarWidth,
      };
      store.commit('setUserSettingsDB', updatedUserSettings);
      store.dispatch('putUserSettings', { settings: updatedUserSettings });
    },
    saveNavbarSettings() {
      let menuBarSortArray = [];
      this.sortedDatabases.forEach((e) => {
        menuBarSortArray.push({
          name: e.name,
          position: this.sortedDatabases.findIndex((el) => e.name === el.name),
        });
      });

      setTimeout(() => {
        const settings = { menuBarSortArray: menuBarSortArray };
        this.$store.dispatch('putUserSettings', { settings });
      }, 500);
    },
    sortDatabases() {
      this.sortedDatabases = this.customUserNavItems.map(
        (database) => database
      );
      const customSortArray = JSON.parse(
        JSON.stringify(this.menuBarSortArray || [])
      );
      if (customSortArray.length != 0) {
        // Add unsorted or new created databases to the end of sortArray
        const unsortedDatabases = this.sortedDatabases.filter(
          (e) => !customSortArray.find((a) => e.name === a.name)
        );

        unsortedDatabases.forEach((e) => {
          this.$set(customSortArray, customSortArray.length, {
            name: e.name,
            position: customSortArray.length,
          });
        });

        this.sortedDatabases.sort((a, b) => {
          return (
            customSortArray.findIndex((p) => p.name === a.name) -
            customSortArray.findIndex((p) => p.name === b.name)
          );
        });
      }
    },
    mouseDownOnLeftNavResizable(event) {
      event.preventDefault();
      this.isLeftNavWidthChanging = true;
      document.addEventListener('mousemove', this.resizeLeftNav, false);
    },
    mouseUpOnLeftNavResizable() {
      document.removeEventListener('mousemove', this.resizeLeftNav, false);
      document.removeEventListener(
        'mouseup',
        this.mouseUpOnLeftNavResizable,
        true
      );
      this.isLeftNavWidthChanging = false;
      const updatedUserSettings = {
        ...this.userSettings,
        leftNavbarWidth: this.leftNavbarWidth,
        isShowLeftNavbar: this.isLeftNavbarVisible,
      };
      store.dispatch('putUserSettings', { settings: updatedUserSettings });
    },
    resizeLeftNav(event) {
      document.addEventListener(
        'mouseup',
        this.mouseUpOnLeftNavResizable,
        true
      );
      const newLeftNavWidth = this.leftNavbarWidth + event.movementX;
      if (newLeftNavWidth < 420 && newLeftNavWidth > 210)
        //this.leftNavbarWidth = newLeftNavWidth;
        this.$emit('updateNavWidth', newLeftNavWidth);

      const updatedUserSettings = {
        ...this.userSettings,
        leftNavbarWidth: newLeftNavWidth,
        isShowLeftNavbar: this.isLeftNavbarVisible,
      };
      store.commit('setUserSettingsDB', updatedUserSettings);
    },
    getActionOptions(page) {
      return this.actionOptions.filter((option) => {
        if (option.key === 'edit') {
          const notAllowedToEditDbTypes = ['loadprofile', 'sheet'];
          return (
            this.userHasTableEditPermission(page.access_level) &&
            this.isAdmin &&
            !notAllowedToEditDbTypes.includes(page.type)
          );
        }
        if (option.key === 'rename') {
          return this.userHasTableEditPermission(page.access_level);
        } else if (option.key === 'leave') {
          return page.access_level !== 'owner';
        } else {
          return this.userHasTableEditPermission(page.access_level);
        }
      });
    },
    onDropDownItemSelect(type, page) {
      this[type](page.name, page);
    },
    onDataBaseNameChange(database) {
      const formData = new FormData();

      formData.append('value', database.caption);

      updateTableSchema(
        this.user,
        this.selectedTableToRename,
        formData,
        'caption'
      );

      this.databaseList.forEach((db) => {
        if (db.name === this.selectedTableToRename) {
          db.caption = database.caption;
        }
      });

      this.$store.commit('SET_DATABASE_LIST', this.databaseList);
    },
    disableToolTip() {
      this.selectedTableToRename = null;
    },
    toggleCloseButton(value) {
      if (this.isCloseButtonVisible != value) this.isCloseButtonVisible = value;
    },
    onDatabaseIconClick(event, page = null) {
      this.$refs['iconPicker'].setSelectedItemCustom();
      this.activeDatabaseIconSelection = page;
      this.$refs['iconPicker'].$el.style.left = '35px';
      setTimeout(() => {
        const iconPickerReact =
          this.$refs['iconPicker'].$el.getBoundingClientRect();

        if (window.innerHeight - event.clientY < 256) {
          this.iconPickerPosition = event.clientY - iconPickerReact.height;
          this.$refs['iconPicker'].$el.style.top = `${
            event.clientY - iconPickerReact.height
          }px`;
        } else {
          this.iconPickerPosition = null;
          this.$refs['iconPicker'].$el.style.top = `${event.clientY}px`;
        }
      }, 0);
    },
    async updateUrl(icon, page) {
      if (icon.length > 0) {
        const formData = new FormData();
        formData.append('value', icon);
        const updateResponse = await updateTableSchema(
          this.user,
          page.name,
          formData,
          'icon'
        );

        this.sortedDatabases = this.sortedDatabases.map((database) =>
          database.name === page.name
            ? { ...database, icon: updateResponse.Attributes.icon }
            : database
        );
        this.activeDatabaseIconSelection = null;
      }
    },
    moveStart(e, elementID, index) {
      e.preventDefault();
      document.body.style.cursor = 'grabbing';
      this.databaseDraggingObject.isDraggingDatabase = true;
      this.databaseDraggingObject.startingPosition = e.clientY;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );
      this.currentDraggingDbIndex = index;

      this.databaseDraggingObject.parent =
        document.querySelector('.menu-list-item');
      this.databaseDraggingObject.parentRect =
        this.databaseDraggingObject.parent.getBoundingClientRect();
      this.databaseDraggingObject.scrollContainer =
        document.querySelector('.menu-list-wrap');
      const draggableElement = document.getElementById(elementID);
      this.databaseDraggingObject.draggable = draggableElement.cloneNode(true);

      this.databaseDraggingObject.draggable.style.position = 'absolute';
      this.databaseDraggingObject.draggable.style.zIndex = -1;
      this.databaseDraggingObject.draggable.style.margin = '0 30px';
      this.databaseDraggingObject.draggable.style.opacity = -1;
      this.databaseDraggingObject.draggable.style.width = 'calc(100% - 53px)';
      this.databaseDraggingObject.draggable.style.background = 'transparent';

      draggableElement.parentNode.insertBefore(
        this.databaseDraggingObject.draggable,
        draggableElement
      );

      this.activeDropZone = null;
      window.addEventListener('mouseup', this.onMouseEnd);
      document
        .querySelector('.home-main-wrap')
        .addEventListener('mousemove', this.onMouseMoving);
    },
    async onMouseEnd(e) {
      e.preventDefault();
      document.body.style.cursor = 'auto';
      this.databaseDraggingObject.scrollInterval = clearInterval(
        this.databaseDraggingObject.scrollInterval
      );
      // this.databaseDraggingObject.scrollSpeed = 5;

      this.databaseDraggingObject.scrollInterval = null;
      this.databaseDraggingObject.draggable.remove();
      this.databaseDraggingObject.scrollInterval = null;
      this.databaseDraggingObject.isDraggingDatabase = false;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );

      if (this.activeDropZone === this.sortedDatabases.length) {
        this.activeDropZone = this.sortedDatabases.length - 1;
      }
      if (this.activeDropZone !== null && !isNaN(this.activeDropZone)) {
        this.sortedDatabases = this.swapElements(
          this.sortedDatabases,
          this.currentDraggingDbIndex,
          this.activeDropZone
        );
      }
      this.$forceUpdate();
      if (
        this.currentDraggingDbIndex != null &&
        this.activeDropZone != null &&
        this.currentDraggingDbIndex !== this.activeDropZone
      ) {
        await this.$emit(
          'changeDataBaseOrder',
          this.activeDropZone,
          this.currentDraggingDbIndex
        );
        this.activeDropZone = null;
        this.saveNavbarSettings();
      }

      window.removeEventListener('mouseup', this.onMouseEnd);
      document
        .querySelector('.home-main-wrap')
        .removeEventListener('mousemove', this.onMouseMoving);
    },
    onMouseMoving(e) {
      e.preventDefault();
      this.databaseDraggingObject.draggableRect =
        this.databaseDraggingObject.draggable.getBoundingClientRect();
      const containerRect =
        this.databaseDraggingObject.scrollContainer.getBoundingClientRect();
      const isMovingAllow =
        e.clientY >= containerRect.top - 10 &&
        e.clientY < containerRect.bottom - containerRect.top / 2 + 10;
      if (isMovingAllow) {
        this.databaseDraggingObject.draggable.style.top = `${
          e.clientY - containerRect.top
        }px`;
        if (
          this.databaseDraggingObject.draggableRect.bottom - containerRect.top >
          containerRect.height
        ) {
          this.setDatabaseScrollInterval(1, containerRect);
        } else if (
          this.databaseDraggingObject.draggableRect.top <= containerRect.top
        ) {
          this.setDatabaseScrollInterval(-1, containerRect);
        } else {
          // this.databaseDraggingObject.scrollSpeed = 5;
          this.databaseDraggingObject.scrollInterval = clearInterval(
            this.databaseDraggingObject.scrollInterval
          );
          if (this.databaseDraggingObject.draggable.style.opacity == 1)
            this.activeDropZone = Math.round(
              (this.databaseDraggingObject.draggableRect.top +
                this.databaseDraggingObject.scrollContainer.scrollTop -
                containerRect.top) /
                this.databaseDraggingObject.draggableRect.height
            );
        }
        if (
          this.databaseDraggingObject.startingPosition + 15 < e.clientY ||
          this.databaseDraggingObject.startingPosition - 15 > e.clientY
        )
          this.databaseDraggingObject.draggable.style.opacity =
            this.databaseDraggingObject.draggable.style.zIndex = 1;
      } else {
        if (e.clientY < containerRect.top - 20) {
          this.databaseDraggingObject.draggable.style.top = `${-10}px`;
          this.setDatabaseScrollInterval(-1, containerRect);
        }
        if (e.clientY > containerRect.bottom - containerRect.top / 2 + 10) {
          this.databaseDraggingObject.draggable.style.top = `${
            containerRect.bottom - containerRect.top - 30
          }px`;
          this.setDatabaseScrollInterval(1, containerRect);
        }
      }
    },
    setDatabaseScrollInterval(scrollMultiplierValue, containerRect) {
      if (!this.databaseDraggingObject.scrollInterval)
        this.databaseDraggingObject.scrollInterval = setInterval(() => {
          this.databaseDraggingObject.scrollContainer.scrollTop +=
            scrollMultiplierValue * this.databaseDraggingObject.scrollSpeed;
          if (this.databaseDraggingObject.draggable.style.opacity == 1)
            this.activeDropZone = Math.round(
              (this.databaseDraggingObject.draggableRect.top +
                this.databaseDraggingObject.scrollContainer.scrollTop -
                containerRect.top) /
                this.databaseDraggingObject.draggableRect.height
            );
          // this.databaseDraggingObject.scrollSpeed += 0.7;
        }, 100);
    },
    swapElements(array, fromIndex, toIndex) {
      const element = array[fromIndex];
      array.splice(fromIndex, 1);
      array.splice(toIndex, 0, element);
      return array;
    },
    onToggleTab(tab) {
      const iconPickerReact =
        this.$refs['iconPicker'].$el.getBoundingClientRect();

      if (this.iconPickerPosition) {
        if (tab === 'icon') {
          this.$refs['iconPicker'].$el.style.top = `${
            this.iconPickerPosition - iconPickerReact.height
          }px`;
        } else {
          this.$refs[
            'iconPicker'
          ].$el.style.top = `${this.iconPickerPosition}px`;
        }
      }
    },
    isScrollWheelActive(event) {
      if (this.databaseDraggingObject.isDraggingDatabase)
        event.preventDefault();
    },
  },
  created() {
    this.fetchUserAccessLevel();
    this.sortDatabases();
  },
  watch: {
    // Sort database on nav change
    'customUserNavItems.length'() {
      this.sortDatabases();
    },
    // 'databaseDraggingObject.translateYValue'(v) {
    //   this.activeDropZone = Math.round(v / 40);
    // },
  },
  computed: {
    ...mapGetters({ getUserId: 'getUserId', databaseList: 'getDatabaseList' }),
    user() {
      return store.state.user;
    },
    isAdmin() {
      return store.state.isAdmin;
    },
    activePage() {
      return this.$route.query.database;
    },
    activeSection() {
      return this.$route.query.section;
    },
    menuBarSortArray() {
      return this.$store.state.userSettings.menuBarSortArray;
    },
    userSettings() {
      return store.state.userSettings;
    },
    getFilteredDatabases() {
      if (this.sortedDatabases && this.sortedDatabases.length > 0) {
        if (this.searchData.search !== null) {
          const filteredDB = [...this.sortedDatabases].filter((el) =>
            el.caption
              .trim()
              .toLowerCase()
              .includes(this.searchData.search.trim().toLowerCase())
          );
          return filteredDB;
        } else {
          return this.sortedDatabases;
        }
      } else {
        return [];
      }
    },
    getDynamicWidth() {
      return this.isLeftNavbarVisible
        ? this.searchData.searchActive
          ? this.leftNavbarWidth - 88 + 'px'
          : '0px'
        : '0px';
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    DropdownComponent,
    IconPicker,
  },
};
</script>

<style>
*,
*::before,
*::after {
  box-sizing: unset;
  -webkit-box-sizing: unset;
}

@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

.nav-left {
  background-color: white;
  color: #f3f7ea;
  padding-bottom: 0;
  position: relative;
  -webkit-box-shadow: 18px -2px 24px -16px rgb(0 0 0 / 36%);
  box-shadow: 20px -2px 30px -15px rgb(0 0 0 / 2%);
  transition: all 300ms ease 0s;
  transform: translateX(-100%);
  z-index: 1;
  width: 0;
  height: 100vh;
}

.nav-left.open {
  transform: translateX(0);
  z-index: 1;
}

.menu1-bar {
  text-transform: uppercase;
  font-size: 10px;
  padding-top: 16px;
}
.nav-left .menu1-bar .list-item.active {
  font-weight: 500;
  color: #fff;
}
.menu1-bar a::selection {
  background: transparent;
}
.menu2-bar {
  font-size: 14px;
  position: relative;
  width: 100%;
  background: white;
  height: 100%;
  color: black;
  left: 0;
  overflow-y: auto;
  height: calc(100% - 85px);
}
.menu2-bar a::selection {
  background: transparent;
}
.menu2-bar a::selection {
  background: transparent;
}

.nav-left .search-bar-container i {
  height: 25px;
  color: black;
}

.nav-left .logo-wrapper {
  width: 100%;
  height: auto;
  padding-bottom: 0;
  -webkit-box-sizing: unset;
  box-sizing: border-box;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.nav-left .logo-wrapper:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  width: calc(100% - 52px);
  height: 1px;
  background: #bebebe;
  opacity: 0;
  visibility: hidden;
}
.nav-left .logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  text-align: left;
  margin: 47px;
  margin-top: -15px;
}
.nav-left .logo img {
  width: 0;
}
.nav-left.open .logo img {
  width: 55px;
}

.title {
  float: left;
  margin: 0 20px 0 0;
  font-size: 33px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: 'Nunito', sans-serif;
  color: white;
}

.nav-left ul li {
  padding: 0;
  margin: 0;
}

.nav-left ul {
  box-sizing: border-box;
  padding: 0 22px 0 30px;
  margin-bottom: 0;
}

.nav-left ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.nav-left ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.nav-left ul li a:hover {
  color: #ffff;
}

.nav-left ul li a:visited {
  color: #9aa4b3;
  text-decoration: none;
}

.nav-left .list-item {
  display: inline-block;
  cursor: pointer;
}

.nav-left .list-item a {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.database-action button {
  padding: 0;
  color: #000;
  width: auto;
  margin-right: 5px;
}

.database-action button:hover {
  color: #000;
}

.nav-left .list-item .dropdown-btn {
  visibility: hidden;
  margin-right: unset;
  /* zoom: 1.1; */
  display: flex;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}
.nav-left .list-item:hover {
  background: rgb(240 240 240 / 45%);
}
.nav-left .list-item:hover .dropdown-btn {
  visibility: visible;
}

.leftnav-icons-wrap {
  position: absolute;
  padding-left: 10px;
  right: 0;
}

.nav-left .list-item:hover .leftnav-icons-wrap {
  position: relative;
  height: 20px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.nav-left .list-item i.visible {
  visibility: visible;
  margin-left: 0px;
  padding-left: 3px;
}

.nav-left .list-item i img {
  margin: 0;
  width: 16px;
}

.nav-left .menu2-bar .list-item {
  vertical-align: middle;
  padding: 9px 0px 7px 0px;
  line-height: 20px;
  width: 100%;
  height: auto;
  margin-bottom: 9px;
}

.nav-left .menu2-bar .list-item.active {
  /* width: 100%; */
  background-color: #f0f0f0;
  border-radius: 3px;
}

.nav-left .Button__button___1FrBC {
  float: right;
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.nav-left ul li a.more {
  background-image: url('../assets/img/tree-dots.png');
  display: inline-block;
  width: 30px;
  height: 22px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: -4px 4px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more {
  background-image: url('../assets/img/tree-dots.png');
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.nav-left ul li a.more:hover {
  background-position: -62px 3px;
}
/* a.sign-out {
  position: absolute;
  right: 20px;
  top: -24px;
} */
.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}

.nav-left .list-item .database-image-wrapper img,
.nav-left .list-item .leftnav-icons-wrap img {
  vertical-align: top;
  border-style: none;
  width: 16px;
  margin-right: 12px;
  padding-left: 2px;
}

.item.last-item {
  border-top: solid 1px #e1e4ea;
}

.item.last-item {
  border-top: solid 1px #e1e4ea;
}

.list-item.last-item:hover {
  background-color: #f0f0f0;
  border-radius: 3px;
}

.nav-left .item:hover {
  background-color: #f0f0f0;
}

.top-left-menu-bar {
  position: relative;
  display: inline-block;
  font-size: 20px;
  top: -20px;
  /* padding-right: 30px; */
}
.top-left-menu-bar img {
  max-width: 35px;
}
.nav-top .logo-wrapper {
  display: flex;
  width: auto;
  margin: 0 100px 0 20px;
}
.toggle-left-nav a {
  display: block;
  padding: 0;
  line-height: 0;
  box-sizing: border-box;
  width: 35px;
  height: 35px;
}
.icon {
  cursor: pointer;
}
.toggle-left-nav .btn-close {
  /* transform: rotate(45deg); */
  font-size: 16px;
  margin-top: 0;
  color: #4f4f54;
  font-weight: 300;
  cursor: pointer;
  box-shadow: none;
}
.toggle-left-nav .round-button.refresh {
  display: block;
  width: 22px;
  margin-right: 15px;
  cursor: pointer;
}

.round-button.refresh.rotation img {
  animation: rotation 1.5s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}

.nav-left .menu2-bar .list-item {
  /* position: absolute; */
  left: 0;
  margin: 0 auto;
  right: 0;
}

span.horizontal-hidden-top-dropping-line {
  /* position: absolute; */
  display: block;
  width: 100%;
  height: 2px;
  top: 0;
  background: transparent;
  left: 0;
}

span.horizontal-hidden-bottom-dropping-line {
  /* position: absolute; */
  display: block;
  width: 100%;
  height: 2px;
  bottom: 0;
  background: transparent;
  left: 0;
}
span.horizontal-hidden-bottom-dropping-line.dragActive,
span.horizontal-hidden-top-dropping-line.dragActive {
  background: black;
}
.vertical-resizable-nav-line {
  height: 100%;
  width: 2px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: ew-resize;
}
.vertical-resizable-nav-line:hover,
.vertical-resizable-nav-line.isResizing {
  background-color: #d1d1d1;
}

.menu2-bar .list-item .item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-navbar-visible img {
  width: 55px;
}

.left-navbar-visible {
  box-sizing: border-box;
  /* padding-left: 0; */
}

.left-menu-list {
  display: flex;
  margin-left: 0;
  align-items: center;
  justify-content: space-between;
}

.left-menu-list-name {
  display: flex;
  width: 100%;
}

.fade-in {
  animation: fadeIn ease 1s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s;
}

.menu-list-item {
  max-height: calc(100% - 150px);
  min-height: 100px;
  overflow-y: auto;
  scrollbar-width: thin;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*rename tooltip */
.rename-tooltip.tooltip.b-tooltip {
  opacity: 1;
}
.rename-popup {
  display: flex;
  width: 380px;
  min-width: 180px;
  max-width: calc(100vw - 24px);
  height: 100%;
  max-height: 70vh;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
}

.rename-tooltip .tooltip-inner {
  border-radius: 4px;
  background: white;
  position: relative;
  max-width: calc(100vw - 24px);
  box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.2) 0px 9px 24px;
  overflow: hidden;
  /* position: relative;
  top: 60px;
  left: 16px; */
}

.rename-popup .icon img {
  height: 20px;
}

.rename-popup .icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;
}

.rename-popup * {
  box-sizing: border-box;
}

.rename-input input {
  font-size: 14px;
  line-height: 20px;
  padding: 4px 10px;
  border-radius: 3px;
  box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset;
  background: rgba(242, 241, 238, 0.6);
  width: 100%;
}
.rename-input input:focus {
  outline: none;
  background: rgba(242, 241, 238, 0.6);
}
.rename-popup .rename-input {
  width: calc(100% - 40px);
}

/*New Bootstrap dropdown*/
.nav-left ul.navbar-dropdown.dropdown-menu {
  border: none;
  width: auto;
  min-width: 130px;
  box-sizing: border-box;
  border: solid 0.1px #f0f0f0;
  bottom: unset;
  padding: 0;
  margin: 10px 0px;
  box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  outline: none;
}

.nav-left ul.navbar-dropdown.dropdown-menu li {
  font-size: 14px;
  color: #000;
  background: #fff;
}
.nav-left ul.navbar-dropdown.dropdown-menu img {
  width: 16px;
}
.nav-left ul.navbar-dropdown.dropdown-menu li a {
  color: #000;
  margin: 0;
  padding: 10px;
  text-overflow: unset;
  width: 100%;
  height: auto;
}

.nav-left ul.navbar-dropdown.dropdown-menu * {
  box-sizing: border-box;
}
.nav-left .list-item .btn:first-child:active:focus-visible {
  box-shadow: none;
}
.nav-left ul.navbar-dropdown.dropdown-menu li a:hover {
  background: #f0f0f0;
  color: #000;
}
.btn:focus-visible {
  box-shadow: none;
  outline: none;
}

.left-bar-bottom {
  position: relative;
}
.left-bar-bottom:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  width: calc(100% - 52px);
  height: 1px;
  background: #bebebe;
}

.scroll-visible.logo-wrapper:before,
.scroll-visible.left-bar-bottom:before {
  opacity: 1;
  visibility: visible;
}
.nav-left .left-bar-bottom {
  padding-top: 16px;
}

.nav-left,
.nav-left * {
  box-sizing: border-box;
}

.leftnav-icons-wrap .b-dropdown {
  height: 25px;
}
.menu-list-wrap {
  /* max-height: calc(100% - 150px); */
  /* max-height: calc(100% - 52px); */
  overflow-y: auto;
  position: relative;
}
.clone-element {
  position: absolute;
  left: 0;
  width: calc(100% - 52px);
  margin: 0 auto;
  right: 0;
  background: transparent;
  padding: 9px 0px 7px 0px;
  line-height: 20px;
  z-index: -1;
  opacity: 0;
}

.clone-element img {
  width: 16px;
  margin-right: 12px;
  padding-left: 2px;
}
.nav-left .list-item .database-image-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
}

.nav-left .menu-list-item .loading-overlay {
  position: absolute;
  background: #1f2532c7;
  width: 100%;
  z-index: 1;
  top: 0;
  text-align: center;
  height: 100%;
  border-radius: 4px;
}
.nav-left .menu-list-item .loading-overlay .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 46%;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
.toast:not(.show) {
  display: block;
}
.search-container {
  padding: 0 27px;
}
.nav-left .search {
  padding: 0;
  height: 44px;
  cursor: auto;
  display: flex;
  border-bottom: solid 2px transparent;
  align-items: center;
}

.nav-left .search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.nav-left .search .search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  /* min-width: 28px; */
  height: 21px;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 0;
  cursor: pointer;
}

.nav-left .search input {
  border: 0;
  height: 36px;
  padding-left: 6px;
  margin-left: 0;
  cursor: initial;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  background: transparent;
  -webkit-transition: width 200ms ease, border-color 200ms ease;
  transition: width 200ms ease, border-color 200ms ease;
  color: #47506e;
}

.nav-left .search input:focus {
  outline: none;
}
.menu-list-wrap.position-unset {
  position: unset;
}
.menu2-bar::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
.left-bar-bottom-overlay {
  height: 100%;
  width: 100%;
  z-index: 9999;
  position: absolute;
  display: block;
}

.nav-left .menu2-bar .list-item.no-item {
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-left .menu2-bar .list-item.no-item:hover {
  background: transparent;
  cursor: default;
}
</style>
